export const CURRENCY_SYMBOL_BLACK_LIST = ['CRC']